<template>
    <div class="video-gallery">
        <div class="video-gallery__highlighted-video-wrapper">
            <div class="video-gallery__highlighted-iframe-wrapper">
                <iframe id="ytplayer" allow="fullscreen" type="text/html" :src="highlightedVideoEmbedUrl"></iframe>
            </div>
        </div>
        <div class="video-gallery__highlighted-video__content">
            <span class="video-gallery__highlighted-video__content__title">
                {{ highlightedVideo.title }}
            </span>
            <p class="video-gallery__highlighted-video__content__description">
                {{ highlightedVideo.description }}
            </p>
        </div>
        <div class="video-gallery__other-videos-list">
            <span class="video-gallery__other-videos-list__title">
                Related videos
            </span>
            <div class="video-gallery__other-videos-list__videos-wrapper">
                <a
                    v-for="video in otherVideos"
                    :key="video.id"
                    class="video-gallery__other-video"
                    @click="setHighlightedVideo(video.id)"
                >
                    <div class="video-gallery__other-video__visual">
                        <img
                            :src="fetchThumbnailImage(retrieveVideoIdFromUrl(video.video_url))"
                            alt="image alt"
                            class="video-gallery__other-video__thumbnail"
                        />
                        <div class="video-gallery__other-video__watch-label">
                            <span class="video-gallery__other-video__icon">
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="/build/svgs/sprite.min.svg#video-play" />
                                </svg>
                            </span>
                            <span>
                                Watch
                            </span>
                        </div>
                    </div>
                    <span class="video-gallery__other-video__video-title">{{ video.title }}</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        videosArrayJson: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            videos: [],
            highlightedVideo: {
                id: '',
                title: '',
                description: '',
                video_url: '',
                thumbnailImage: '',
            },
            otherVideos: [],
            videoPlaying: false,
            isSwitchingVideo: false,
        };
    },
    mounted() {
        this.videos = [...JSON.parse(this.videosArrayJson)];
        this.setHighlightedVideo(this.videos[0].id);
    },
    methods: {
        setHighlightedVideo(videoId) {
            this.isSwitchingVideo = true;
            console.log(this.isSwitchingVideo);
            this.highlightedVideo = this.videos.find(video => video.id === videoId);
            this.otherVideos = this.videos.filter(video => video.id !== this.highlightedVideo.id);
            this.isSwitchingVideo = false;
            this.setHighlightedVideoEmbedUrl(this.highlightedVideo.video_url);
        },
        setHighlightedVideoEmbedUrl(url) {
            this.highlightedVideoEmbedUrl = `https://www.youtube.com/embed/${this.retrieveVideoIdFromUrl(
                url
            )}?autoplay=0`;
        },
        retrieveVideoIdFromUrl(url) {
            const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
            const match = url.match(regex);
            return match ? match[1] : null;
        },
        fetchThumbnailImage(videoId) {
            return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
        },
    },
};
</script>
